// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"34":"78b03f91","98":"9e4ccd64","219":"d42b5b1e","478":"b4d3c021","783":"72a017a8","882":"4609b5fc"}[chunkId] + ".chunk.js";
};